var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0122 0.177999L23.7798 10.54C23.9582 10.7742 24.1964 11.383 23.7213 11.945L15.0122 22.2485C14.8953 22.3656 14.7784 22.4241 14.6031 22.4241C14.3108 22.4241 14.0186 22.1314 14.0186 21.7802V16.5113C13.2587 16.2186 11.0961 15.6917 7.53063 17.2139C3.02998 19.1458 1.56873 24.4731 1.56873 24.5317C1.51028 24.8244 1.27648 25 1.04268 25C0.808875 25 0.516624 24.8829 0.458174 24.5902C-0.652377 20.0824 0.282824 15.282 2.97153 11.5938C5.60178 7.9056 9.69329 5.73953 14.0186 5.68099V0.646339C14.0186 0.412169 14.1355 0.177999 14.3693 0.0609145C14.6031 -0.0561704 14.8953 0.00237204 15.0122 0.177999Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.82f9b1ca10ebafc7cd2dc32985e4013c.svg";
export { ForwardRef as ReactComponent };